// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"648":"7d78d5e9","842":"0ff7d119"}[chunkId] + ".chunk.js";
};